import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import {catchError, map} from 'rxjs/operators'
import { AnalyticsService } from '../_services/sdk/analytics/analytics.service';
import { DDActions } from '../_constants/app.constants';

/**
 * This class is for intercepting http requests.
 * @class {HttpRequestInterceptor}
 */
@Injectable()
export class AnalyticsInterceptor implements HttpInterceptor {

  constructor(
    private analyticsService: AnalyticsService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      request.url.indexOf('/api/auth') >= 0 ||
      request.url.indexOf('/api/language') >= 0 ||
      request.url.indexOf('/api/airport') >= 0
    ) return next.handle(request)
    this.analyticsService.addAction(DDActions.API_REQUEST, request)
    return next.handle(request)
      .pipe(catchError((err) => {
        return throwError(() => new Error(err));
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this.analyticsService.addAction(DDActions.API_RESPONSE, evt)
        }
        return evt;
      }));
  }

}

export const AnalyticsProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AnalyticsInterceptor,
  multi: true
}